import { useEffect, useState } from 'react';
import {
	acquireGrafanaAuthSession,
	releaseGrafanaAuthSession,
} from '../services/grafanaAuthSession';

const useGrafanaAuthSession = (sessionKey = true) => {
	const active = Boolean(sessionKey);
	const [readyKey, setReadyKey] = useState(null);

	useEffect(() => {
		if (!active) {
			setReadyKey(null);
			return undefined;
		}

		let cancelled = false;

		acquireGrafanaAuthSession()
			.then(() => {
				if (!cancelled) setReadyKey(sessionKey);
			})
			.catch(() => {
				if (!cancelled) setReadyKey(null);
			});

		return () => {
			cancelled = true;
			releaseGrafanaAuthSession();
		};
	}, [active, sessionKey]);

	return active && readyKey === sessionKey;
};

export default useGrafanaAuthSession;
